import {
  REQUEST_DRIVERS,
  RESPONSE_DRIVERS,
  REQUEST_DRIVERS_FAULURE,
  SELECT_DRIVER,
  SELECT_DRIVER_FOR_UNITS,
  REQUEST_CREATE_DRIVER,
  RESPONSE_CREATE_DRIVER,
  REQUEST_CREATE_DRIVER_FAULURE,
  REQUEST_UPDATE_DRIVER,
  RESPONSE_UPDATE_DRIVER,
  REQUEST_UPDATE_DRIVER_FAULURE,
  REQUEST_DELETE_DRIVER,
  RESPONSE_DELETE_DRIVER,
  REQUEST_DELETE_DRIVER_FAULURE,
  REQUEST_DOWNLOAD_DRIVERS,
  RESPONSE_DOWNLOAD_DRIVERS,
  REQUEST_DOWNLOAD_DRIVERS_FAULURE,
} from "../actions/driversAction";

import { states } from "./queriesStates";

const initialState = {
  driversDataState: states.NOT_REQUESTED,
  driverCreateDataState: states.NOT_REQUESTED,
  driverUpdateDataState: states.NOT_REQUESTED,
  driverDeleteDataState: states.NOT_REQUESTED,
  driversDownloadDataState: states.NOT_REQUESTED,
  drivers: [],
  selectedDriver: null,
  driverForUnits: null,
  errors: [],
};

const driversReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_DRIVERS:
      return Object.assign({}, state, {
        driversDataState: states.REQUEST,
      });
    case RESPONSE_DRIVERS:
      return Object.assign({}, state, {
        driversDataState: states.READY,
        drivers: action.data.drivers,
      });
    case REQUEST_DRIVERS_FAULURE:
      return Object.assign({}, state, {
        driversDataState: states.FAILURE,
        errors: action.errors,
      });

    case SELECT_DRIVER:
      return Object.assign({}, state, {
        selectedDriver: action.data,
      });

    case SELECT_DRIVER_FOR_UNITS:
      return Object.assign({}, state, {
        driverForUnits: action.data,
      });

    case REQUEST_CREATE_DRIVER:
      return Object.assign({}, state, {
        driverCreateDataState: states.REQUEST,
      });
    case RESPONSE_CREATE_DRIVER:
      return Object.assign({}, state, {
        driverCreateDataState: states.READY,
        drivers: state.drivers.concat(action.data),
      });
    case REQUEST_CREATE_DRIVER_FAULURE:
      return Object.assign({}, state, {
        driverCreateDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_UPDATE_DRIVER:
      return Object.assign({}, state, {
        driverUpdateDataState: states.REQUEST,
      });
    case RESPONSE_UPDATE_DRIVER:
      return Object.assign({}, state, {
        driverUpdateDataState: states.READY,
        drivers: state.drivers.map((x) => {
          if (x.id === action.data.id) {
            return action.data;
          }

          return x;
        }),
      });
    case REQUEST_UPDATE_DRIVER_FAULURE:
      return Object.assign({}, state, {
        driverUpdateDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_DELETE_DRIVER:
      return Object.assign({}, state, {
        driverDeleteDataState: states.REQUEST,
      });
    case RESPONSE_DELETE_DRIVER:
      return Object.assign({}, state, {
        driverDeleteDataState: states.READY,
        drivers: state.drivers.filter((x) => {
          return x.id !== action.data.id;
        }),
      });
    case REQUEST_DELETE_DRIVER_FAULURE:
      return Object.assign({}, state, {
        driverDeleteDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_UPDATE_DRIVER_FAULURE:
      return Object.assign({}, state, {
        driverUpdateDataState: states.FAILURE,
        errors: action.errors,
      });

    case REQUEST_DOWNLOAD_DRIVERS:
      return Object.assign({}, state, {
        driversDownloadDataState: states.REQUEST,
      });
    case RESPONSE_DOWNLOAD_DRIVERS:
      return Object.assign({}, state, {
        driversDownloadDataState: states.READY,
      });
    case REQUEST_DOWNLOAD_DRIVERS_FAULURE:
      return Object.assign({}, state, {
        driversDownloadDataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default driversReducer;
